import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	jsonArrayProperty,
	jsonProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'

export const GeneratedByOptions = [
	['manually', 'Manually'],
	['letsencrypt', 'LetsEncrypt'],
] as const

@jsonClass('TlsCertificate')
export class TlsCertificate {
	@jsonProperty(Number)
	id: number = 0
	@jsonProperty(String)
	name: string = ''
	@jsonArrayProperty(String)
	subjectNames: string[] = ['hostname.mycompany.com']
	@jsonProperty(String)
	certificatePem: string = ''
	@jsonProperty(String)
	keyPem: string = ''
	@jsonProperty(String)
	keyPassword: string = ''
	@jsonProperty(Number)
	order!: number

	@jsonProperty(Date)
	validFrom!: Date
	@jsonProperty(Date)
	validUntil!: Date
	@jsonProperty(String)
	generatedBy: 'letsencrypt' | 'manually' = 'manually'
	@jsonProperty(Number)
	regenerateDaysBeforeExpiry: number = 0

	constructor(init?: Partial<TlsCertificate>) {
		assignCommonProperties(this, init)
	}

	getSubjectRegex() {
		const names = this.subjectNames.map(
			(sn) => `(${sn.replace('.', '\\.').replace('*', '.*')})`,
		)
		const regex = new RegExp(`^${names.join('|')}$`, 'i')

		return regex
	}
}
